<template lang="html">
  <!-- <v-container grid-list-md :fluid="$vuetify.breakpoint.xlOnly"> -->
  <v-container grid-list-lg :fluid="true" class="pa-3 bgs-container">
    <v-layout v-bind="binding">

      <v-flex xs12 sm12 md12 lg3 xl2>
        <v-card class="filters-container">
          <v-system-bar color="accent" dark window @click.native="isFiltersVisible = !isFiltersVisible" style="cursor: pointer;">
            <v-icon center>filter_list</v-icon>
            <v-toolbar-title class="ml-0">Фильтры</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon class="mx-0">
              <v-icon class="mx-0">{{ isFiltersVisible ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-system-bar>
          <v-slide-y-transition>
            <v-card-text v-show="isFiltersVisible" class="pa-0">
              <template v-if="filterLoadingError">
                <v-alert :value="true" type="error" outline>
                  Произошла ошибка при загрузке фильтров
                </v-alert>
                <v-btn color="secondary" small @click="getFiltersData()">
                  <v-icon left>cached</v-icon>
                  Повторить
                </v-btn>
              </template>
              <FilterContainer v-else
                :loading="loadingFilters" 
                :filters="filters" 
                v-on:filtersChange="onFiltersChange" 
              />
            </v-card-text>
          </v-slide-y-transition>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md12 lg9 xl10>
        <v-card>
          <v-system-bar color="accent" dark window>
            <v-icon center>list</v-icon>
            <v-toolbar-title class="ml-0">Список процессов</v-toolbar-title>
          </v-system-bar>
          <v-card-text>
            <template v-if="dataLoadingError">
              <v-alert :value="true" type="error" outline>
                Произошла ошибка при загрузке данных
              </v-alert>
              <v-btn small @click="getListData()">
                <v-icon left>cached</v-icon>
                Повторить
              </v-btn>
            </template>
            <v-data-table v-else
                          :headers="headers"
                          :items="items"
                          :pagination.sync="pagination"
                          :total-items="totalItems"
                          :loading="loading"
                          class="monitor-data-table"
                          id="process-list-table"
                          item-key="id"
                          rows-per-page-text="Элементов на страницу"
                          :rows-per-page-items="rowsPerPageDefault"
                          no-data-text="Нет доступных данных"
                          no-results-text="Не найдено подходящих значений"
            >
              <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded; selectItem( props.item )" :class="{ 'selected-row': currentItem && props.item.id === currentItem.id }">
                  <td>
                    <template v-if="props.item.tags">
                      <strong v-if="props.item.tags.self" v-text="props.item.tags.self"></strong>
                      <small v-if="props.item.tags.parent" v-text="props.item.tags.parent"></small>
                    </template>
                    <template v-else>&nbsp;</template>
                  </td>
                  <td class="text-xs-left">{{ props.item.start_port_name }}</td>
                  <!-- <td class="text-xs-right">{{ getStatusName(props.item.status) }}</td> -->
                  <td class="text-xs-center">
                    <v-chip outline :color="getStatusColor( props.item.status )" disabled small>
                      <!-- {{ props.item.statusName }} -->
                      {{ getStatusName( props.item.status ) }}
                    </v-chip>
                  </td>
                  <td class="text-xs-left">
                    <d-being v-if="props.item.contractor_id" :id="props.item.contractor_id" type="post">
                      <div slot="default" slot-scope="{ being, type, data }">
                        <v-chip v-if="being.loaded !== false" disabled small>
                          <v-avatar>
                            <being-avatar :being="being" />
                          </v-avatar>
                          {{ being.fullname }}&nbsp;/&nbsp;<small>{{ being.name }}</small>
                        </v-chip>
                        <template v-else>
                          <loading flat :message="false" progress="circular" color="primary" size="24" width="2" />
                        </template>
                      </div>
                    </d-being>
                    <v-chip v-else disabled small>
                      <v-avatar>
                        <v-icon>mdi-account-off</v-icon>
                      </v-avatar>
                      отсутствует
                    </v-chip>
                  </td>
                  <!-- <td class="text-xs-left">{{ props.item.created_at }}</td> -->
                  <td class="text-xs-left">{{ getHumanDateFromSec( props.item.created_at ) }}</td>
                  <!-- <td class="text-xs-center">{{ props.item.runningValue }} %</td> -->
                  <td class="text-xs-left">{{ getProgressValue( props.item ) }}</td>
                </tr>
              </template>
    
              <template slot="expand" slot-scope="props">
                <v-container grid-list-md fluid class="bgs-container pa-3">
                  <!-- <div class="bgs-container"> -->
                  <v-layout row wrap>
          
                    <v-flex xs12 v-if="props.item.description">
                      <!-- <h3 class="title mb-1">Описание</h3> -->
                      <p><span>Описание бизес-процесса:</span><br/>{{ props.item.description }}</p>
                    </v-flex>
          
                    <!-- Начало / Запуск -->
                    <v-flex xs12 sm12 md4>
                      <v-card>
                        <v-system-bar window dark color="accent">
                          <v-icon center>mdi-numeric-1-box-outline</v-icon>
                          <v-toolbar-title class="subheading ml-0">Начало / Запуск</v-toolbar-title>
                        </v-system-bar>
                        <v-list dense two-line class="properties-height">
                          <!-- Customer Info -->
                          <d-being v-if="props.item.customer_id" :id="props.item.customer_id" type="post">
                            <div slot="default" slot-scope="{ being, type, data }">
                              <v-list-tile v-if="being.loaded !== false">
                                <!-- Данные загружены -->
                                <v-list-tile-avatar>
                                  <being-avatar :being="being" />
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ being.fullname }}&nbsp;/&nbsp;<small>{{ being.name }}</small></v-list-tile-title>
                                  <v-list-tile-sub-title>Запустивший процесс</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-list-tile v-else avatar>
                                <!-- Загрузка -->
                                <v-list-tile-avatar>
                                  <v-icon>face</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <loading flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                </v-list-tile-content>
                              </v-list-tile>
                            </div>
                          </d-being>
                          <v-list-tile v-else>
                            <v-list-tile-avatar>
                              <v-icon>mdi-account-off</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>отсутствует</v-list-tile-title>
                              <v-list-tile-sub-title>Запустивший процесс</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                
                          <template
                            v-for="(itemProp, index) in getMonitorItemProperties( props.item, ['created', 'started', 'time_limit', 'instruction'] )"
                            v-if="itemProp.title || itemProp.subTitle"
                          >
                  
                            <v-list-tile v-if="itemProp.command" :avatar="itemProp.avatar" v-on:click="itemProp.command" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <UserInfoPopup v-else-if="itemProp.user" :user="itemProp.user"></UserInfoPopup>
                                <v-btn color="secondary" v-else-if="itemProp.action" icon disabled>
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                  
                            <v-list-tile v-else :avatar="itemProp.avatar" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <UserInfoPopup v-else-if="itemProp.user" :user="itemProp.user"></UserInfoPopup>
                                <v-btn color="secondary" v-else-if="itemProp.action" icon disabled>
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                
                          </template>
                        </v-list>
                        <!-- Instruction text. -->
                        <v-slide-y-transition v-if="props.item.instruction">
                          <v-card-text v-show="isInstructionVisible">
                            <v-card>
                              <v-card-text v-html="props.item.instruction" />
                            </v-card>
                          </v-card-text>
                        </v-slide-y-transition>
                      </v-card>
                    </v-flex>
          
                    <!-- Исполнение -->
                    <v-flex xs12 sm12 md4>
                      <v-card>
                        <v-system-bar window dark
                                      color="accent"
                                      :class="{
                          'pink': ['hold', 'pool', 'pending'].includes(props.item.status),
                          'orange': ['running',].includes(props.item.status),
                          'green': ['finished'].includes(props.item.status),
                          'blue-grey': ['canceled'].includes(props.item.status)
                        }"
                        >
                          <v-icon center>mdi-numeric-2-box-outline</v-icon>
                          <v-toolbar-title class="subheading ml-0">Исполнение</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <!-- Show context actions menu only for not canceled items. -->
                          <v-menu bottom left v-if="!['finished', 'canceled'].includes(props.item.status)">
                            <v-btn small icon slot="activator">
                              <v-icon class="mx-0">more_vert</v-icon>
                            </v-btn>
                            <v-list>
                              <v-list-tile @click="executorReplace()" v-if="props.item.contractor_id && ['running', 'pending'].includes(props.item.status)">
                                <v-list-tile-avatar>
                                  <v-icon>people</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>Заменить исполнителя</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="executorAssign()" v-if="!props.item.contractor_id && ['pool'].includes(props.item.status)">
                                <v-list-tile-avatar>
                                  <v-icon>person_add</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>Назначить исполнителя</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="executorDismiss()" v-if="props.item.contractor_id && ['running', 'pending'].includes(props.item.status)">
                                <v-list-tile-avatar>
                                  <v-icon>person_outline</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>Снять исполнителя</v-list-tile-title>
                              </v-list-tile>
                    
                              <v-divider></v-divider>
                    
                              <v-list-tile @click="processHold()" v-if="['pool', 'running', 'pending'].includes(props.item.status)" :disabled="!props.item.can_hold">
                                <v-list-tile-avatar>
                                  <v-icon>ac_unit</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>Заморозить процесс</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="processResume()" v-if="['hold'].includes(props.item.status)">
                                <v-list-tile-avatar>
                                  <v-icon>ac_unit</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>Разморозить процесс</v-list-tile-title>
                              </v-list-tile>
                              <v-list-tile @click="processCancel()" v-if="['pool', 'pending', 'running', 'hold'].includes(props.item.status)">
                                <v-list-tile-avatar>
                                  <v-icon>cancel</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-title>Отменить исполнение процесса</v-list-tile-title>
                              </v-list-tile>
                            </v-list>
                          </v-menu>
                        </v-system-bar>
                        <v-list dense two-line class="properties-height">
                          <!-- Contractor Info -->
                          <d-being v-if="props.item.contractor_id" :id="props.item.contractor_id" type="post">
                            <div slot="default" slot-scope="{ being, type, data }">
                              <v-list-tile v-if="being.loaded !== false">
                                <!-- Данные загружены -->
                                <v-list-tile-avatar>
                                  <being-avatar :being="being" />
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ being.fullname }}&nbsp;/&nbsp;<small>{{ being.name }}</small></v-list-tile-title>
                                  <v-list-tile-sub-title>Исполнитель</v-list-tile-sub-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-list-tile v-else avatar>
                                <!-- Загрузка -->
                                <v-list-tile-avatar>
                                  <v-icon>face</v-icon>
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                  <loading flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                </v-list-tile-content>
                              </v-list-tile>
                            </div>
                          </d-being>
                          <v-list-tile v-else>
                            <v-list-tile-avatar>
                              <v-icon>mdi-account-off</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>Не назначен</v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                
                          <template
                            v-for="(itemProp, index) in getMonitorItemProperties( props.item, ['executed', 'deadline', 'hold', 'canceled', 'input'] )"
                            v-if="itemProp.title || itemProp.subTitle"
                          >
                            <v-list-tile v-if="itemProp.command" :avatar="itemProp.avatar" v-on:click="itemProp.command" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <UserInfoPopup v-else-if="itemProp.user" :user="itemProp.user"></UserInfoPopup>
                                <v-btn color="secondary" v-else-if="itemProp.action" icon disabled>
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-else :avatar="itemProp.avatar" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <UserInfoPopup v-else-if="itemProp.user" :user="itemProp.user"></UserInfoPopup>
                                <v-btn color="secondary" v-else-if="itemProp.action" icon disabled>
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </template>
                        </v-list>
                        <!-- Наборы входящих данных -->
                        <v-slide-y-transition v-if="props.item.data && props.item.data.input">
                          <v-card-text v-show="isInputDataVisible">
                            <div class="mb-2" v-for="(dataItem, indexData) in props.item.data.input" :key="indexData">
                              <!--<span class="body-2"><b>{{ dataItem.name }}:</b></span>-->
                              <!--<span class="body-1">{{ dataItem.value }}</span>-->
                              <DataItemRow :data-item="dataItem"></DataItemRow>
                            </div>
                          </v-card-text>
                        </v-slide-y-transition>
                      </v-card>
                    </v-flex>
          
                    <!-- Завершение -->
                    <v-flex xs12 sm12 md4>
                      <v-card>
                        <v-system-bar window dark
                                      color="accent"
                                      :class="{
                          'pink': ['hold', 'pool', 'pending', 'running'].includes(props.item.status),
                          'green': ['finished'].includes(props.item.status),
                          'blue-grey': ['canceled'].includes(props.item.status)
                        }">
                          <v-icon center>mdi-numeric-3-box-outline</v-icon>
                          <v-toolbar-title class="subheading ml-0">Завершение</v-toolbar-title>
                        </v-system-bar>
                        <v-list dense two-line class="properties-height">
                          <template
                            v-for="(itemProp, index) in getMonitorItemProperties( props.item, ['status', 'finished', 'output'] )"
                            v-if="itemProp.title || itemProp.subTitle"
                          >
                            <v-list-tile v-if="itemProp.command" :avatar="itemProp.avatar" v-on:click="itemProp.command" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <UserInfoPopup v-else-if="itemProp.user" :user="itemProp.user"></UserInfoPopup>
                                <v-btn color="secondary" v-else-if="itemProp.action" icon disabled>
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-else :avatar="itemProp.avatar" :disabled="itemProp.disabled ? true : false">
                              <v-list-tile-avatar>
                                <img v-if="itemProp.image" :src="itemProp.image"/>
                                <v-icon v-else-if="itemProp.avatarIcon">{{ itemProp.avatarIcon }}</v-icon>
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title v-if="itemProp.title">{{ itemProp.title }}</v-list-tile-title>
                                <v-list-tile-sub-title v-if="itemProp.subTitle">{{ itemProp.subTitle }}</v-list-tile-sub-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <loading v-if="itemProp.loading" flat :message="false" progress="circular" color="primary" size="32" width="3" />
                                <UserInfoPopup v-else-if="itemProp.user" :user="itemProp.user"></UserInfoPopup>
                                <v-btn color="secondary" v-else-if="itemProp.action" icon disabled>
                                  <v-icon v-html="itemProp.actionIcon"></v-icon>
                                </v-btn>
                              </v-list-tile-action>
                            </v-list-tile>
                          </template>
                        </v-list>
                        <!-- Наборы исходящих данных -->
                        <v-slide-y-transition v-if="props.item.data && props.item.data.output">
                          <v-card-text v-show="isOutputDataVisible">
                            <v-card flat>
                              <v-toolbar card color="accent" dense>
                                <v-toolbar-title class="subheading">Выходной порт</v-toolbar-title>
                              </v-toolbar>
                              <v-card-text>
                                <div class="mb-2" v-for="(dataItem, indexData) in props.item.data.output" :key="indexData">
                                  <div class="body-2"><b>{{ dataItem.name }}:</b></div>
                                  <div class="body-1">{{ dataItem.value }}</div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                        </v-slide-y-transition>
                      </v-card>
                    </v-flex>
        
                  </v-layout>
                  <!-- </div> -->
                </v-container>
              </template>
            </v-data-table>
          </v-card-text>
          
        </v-card>
      </v-flex>

      <!-- Dialog components -->
      <LoadingModal :visible="isLoadingModalVisible" />

      <InfoMessageModal
        :visible="isInfoModalVisible"
        :message="dialogMessage"
        v-on:cancel="isInfoModalVisible = false"
        v-on:confirm="isInfoModalVisible = false"
      />

      <ConfirmMessageModal
        :visible="isConfirmModalVisible"
        :message="dialogMessage"
        confirmText="Подтвердить"
        v-on:cancel="isConfirmModalVisible = false"
        v-on:confirm="callMethod(dialogConfirmCB, true )"
      />

      <ExecutorsModal
        :visible="isExecutorsModalVisible"
        :list="executorsList"
        v-on:confirm="executorAssign"
        v-on:cancel="isExecutorsModalVisible = false"
      />

    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from 'lodash'
import { mapGetters } from 'vuex'

import apiRoutes from '../api/routes'
import httpClient from '@/api/http-client'
const http = httpClient.http

import commons from '../../mixins/commons'
import time_limit from '../../mixins/time_limit'
import monitor from '../../mixins/monitor'
import monitor_item_properties from '../../mixins/monitor_item_properties'
import filtered_list_routing from '../../mixins/filtered_list_routing'

import FilterContainer from '../../components/FilterContainer'
import BeingAvatar from '../../components/BeingAvatar'

import UserInfoPopup from '../components/UserInfoPopup'
import ItemDataPopup from '../components/ItemDataPopup'
import ExecutorsModal from '../components/ExecutorsModal'
import LoadingModal from '../components/utils/LoadingModal'
import InfoMessageModal from '../components/utils/InfoMessageModal'
import ConfirmMessageModal from '../components/utils/ConfirmMessageModal'

import DBeing from '@/components/Being'
import DataItemRow from '../../components/DataItemRow'

const consoleDebug = Boolean(process.env.NODE_ENV == 'development')

// import { getPost } from './ItemsProperties'

export default {
  mixins: [
    commons,
    time_limit,
    monitor,
    filtered_list_routing,
    monitor_item_properties
  ],

  components: {
    DataItemRow,
    FilterContainer,
    UserInfoPopup,
    ItemDataPopup,
    LoadingModal,
    InfoMessageModal,
    ConfirmMessageModal,
    ExecutorsModal,
    DBeing,
    BeingAvatar
  },

  computed: {
    ...mapGetters('app/layout', ['getRouteData']),
    binding () {
      const binding = {}

      if (this.$vuetify.breakpoint.mdAndDown) binding.column = true
      else binding.row = true

      return binding
    }
  },

  data () {
    return {
      currentItem: {},

      headers: [
        { text: 'Метка', align: 'left', sortable: true, value: 'tag' },
        { text: 'Заголовок', align: 'left', sortable: true, value: 'title' },
        { text: 'Статус', align: 'center', sortable: true, value: 'status' },
        { text: 'Исполнитель', align: 'left', sortable: true, value: 'contractor' },
        { text: 'Создан', align: 'left', sortable: true, value: 'created' },
        { text: 'Срок выполнения', align: 'left', sortable: false, value: 'time_limit' },
      ],

      portDataHeaders: [
        { text: 'Заголовок', align: 'left', sortable: false, value: 'labelPD' },
        { text: 'Значение', align: 'left', sortable: false, value: 'valuePD' }
      ],

      isFiltersVisible: true,

      dialogMessage: '',
      dialogConfirmCB: '',

      executorsList: [],

      isLoadingModalVisible: false,
      isInfoModalVisible: false,
      isConfirmModalVisible: false,
      isStartExecutionDialogVisible: false,
      isFinishExecutionDialogVisible: false,
      isFlexFormDialogVisible: false,
      isExecutorsModalVisible: false,

      dataLoadingError: false,
      filterLoadingError: false
    }
  },

  methods: {
    getListData: function () {
      this.loading = true
      this.dataLoadingError = false
      this.items = []
      this.totalItems = 0

      let apiPath = apiRoutes.monitor.processes
      let params = {
        page_num: this.pagination.page,  
        page_size: this.pagination.rowsPerPage,
        sort_by: this.pagination.sortBy,
        descending: this.pagination.descending,
        filters: {}
      }

      // If there are some active (selected) filters:
      for (let filter in this.inputFilters) {
        if( this.inputFilters.hasOwnProperty( filter ) ) {
          if (Array.isArray(this.inputFilters[filter]) && this.inputFilters[filter].length) {
            params.filters[filter] = []

            this.inputFilters[filter].forEach( element => {
              params.filters[filter].push( element )
            } )
          }
        }
      }

      // NOTE: необходима сериализация параметров запроса из-за фильтров: 
      //  фильтры представляют из себя структуру с большей глубиной вложенности, 
      //  чем позволяет axios передавать в качестве параметров
      // http.get( apiPath, { params: params } ).then(response => {
      http.get( apiPath + '?' + this.serializeObject( params ) ).then(response => {
        if ( response.status == 200 && response.data && Array.isArray(response.data.list)) {
          this.items = response.data.list

          this.totalItems = response.data && response.data.total_count
            ? response.data.total_count
            : 0
        } else {
          this.dataLoadingError = true
          this.$dmsErrorNoty('Произошла ошибка при загрузке данных')
        }
      }).catch(error => {
        console.warn(error)
        this.dataLoadingError = true
        this.$dmsErrorNoty('Произошла ошибка при загрузке данных')
      }).finally(() => {
        this.loading = false
      })
    },

    getFiltersData: function () {
      this.loadingFilters = true
      this.filterLoadingError = false
      this.filters = []

      let apiPath = apiRoutes.filter.index
      http.get( apiPath ).then(response => {
        if (response.status == 200 && response.data) {
          let filters = response.data

          // After loading filters set selected values.
          // NOTE: 1. Works good
          this.applyInputFilters( filters )
          this.filters = filters
          // NOTE: 2. Breaks filters watcher
          // this.filters = response.data
          // this.applyInputFilters( this.filters )
        } else {
          this.$dmsErrorNoty('Произошла ошибка при загрузке фильтров')
          this.filterLoadingError = true
        }
      }).catch(error => {
        console.warn(error)
        this.filterLoadingError = true
        this.$dmsErrorNoty('Произошла ошибка при загрузке фильтров')
      }).finally(() => {
        this.loadingFilters = false
      })
    },

    /**
     * Обновление информации об исполнителях и пользователях, запустивших процесс.
     */
    updateBeingsInfo: function( items ) {
      for (let i = 0; i < items.length; i++) {
        let item = items[i]

        if (item.contractor_id) {
          // TODO:
          this.$store.dispatch('orgStructure/postQuickInfo', {
            postId: item.contractor_id
          })
        }

        if (item.customer_id) {
          // TODO:
          this.$store.dispatch('orgStructure/postQuickInfo', {
            postId: item.customer_id
          })
        }
      } // for

      return items
    },

    executorAssign: function( confirmed = false, executor = null ) {
      let apiPath = ''

      this.isConfirmModalVisible = false
      this.dialogMessage = ''
      this.dialogConfirmCB = ''

      if ( executor ) {
        // Have executor ID to assign

        this.isLoadingModalVisible = true

        // Clear modal data
        this.isExecutorsModalVisible = false
        this.executorsList = []
        this.dialogConfirmCB = ''

        // Send server request
        apiPath = apiRoutes.monitor.contractors.assign
        apiPath = apiPath.replace('{process_id}', this.currentItem.id)
        apiPath = apiPath.replace('{contractor_id}', executor.id)

        http.patch( apiPath ).then(response => {
          if (consoleDebug) {
            console.log("Ответ сервера на 'monitor.contractors.assign' процесса:")
            console.log(response)
          }

          this.isLoadingModalVisible = false

          if ( response.status == 200 ) {
            this.dialogMessage = 'Новый исполнитель успешно назначен.'
            this.isInfoModalVisible = true
          } else {
            this.dialogMessage = 'Произошла ошибка при обращении к серверу.'
            this.isInfoModalVisible = true
          }

          // Update item data.
          this.uploadItem( this.currentItem )
        }).catch(error => {
          console.warn(error)

          this.isLoadingModalVisible = false

          // Show error message.
          this.dialogMessage = 'Произошла ошибка при выполнении операции.'
          this.isInfoModalVisible = true
        })
      } else {
        // Get available executors list from the server.
        if ( this.currentItem && this.currentItem.id ) {
          this.isLoadingModalVisible = true

          apiPath = apiRoutes.monitor.contractors.index.replace('{process_id}', this.currentItem.id)

          http.get( apiPath ).then(response => {
            if (consoleDebug) {
              console.log("Ответ сервера на 'monitor.contractors.index' процесса:", response)
            }

            this.isLoadingModalVisible = false

            if ( response.status == 200 && response.data && response.data.list && Array.isArray(response.data.list) ) {
              let ids = response.data.list

              this.executorsList = response.data.list

              this.dialogConfirmCB = 'executorAssign'
              this.isExecutorsModalVisible = true
            } else {
              this.dialogMessage = 'Данные об исполнителях не получены'
              this.isInfoModalVisible = true
            }
          }).catch(error => {
            console.warn(error)

            this.isLoadingModalVisible = false

            // Show error message.
            this.dialogMessage = 'Произошла ошибка при выполнении операции.'
            this.isInfoModalVisible = true
          })
        }
      }
    },

    executorDismiss: function( confirmed = false ) {
      if (confirmed) {
        this.isConfirmModalVisible = false
        this.dialogMessage = ''

        if (consoleDebug) {
          console.log("Executor will be dismissed.")
        }

        // 1. Show waiting modal.
        // 2. Send server request
        // 3. On success/error:
        //  - close waiting modal
        //  - show ok/error message

        if ( this.currentItem && this.currentItem.id ) {
          this.isLoadingModalVisible = true

          let apiPath = apiRoutes.monitor.contractors.dismiss.replace('{process_id}', this.currentItem.id)

          http.patch( apiPath ).then(response => {
            if (consoleDebug) {
              console.log("Ответ сервера на 'contractors.dismiss' процесса:")
              console.log(response)
            }

            this.isLoadingModalVisible = false

            if ( response.status == 200 ) {
              this.dialogMessage = 'Исполнитель успешно снят.'

              if (consoleDebug) {
                console.log("this.currentItem:")
                console.log(this.currentItem)
              }

              this.uploadItem( this.currentItem )
            } else {
              this.dialogMessage = 'Произошла ошибка при снятии исполнителя.'
            }
            this.isInfoModalVisible = true
          }).catch(error => {
            console.warn(error)

            this.isLoadingModalVisible = false

            // Show error message.
            this.dialogMessage = 'Произошла ошибка при снятии исполнителя.'
            this.isInfoModalVisible = true
          })
        }

      } else {
        this.dialogMessage = 'Подтвердите снятие текущего исполнителя'
        this.dialogConfirmCB = 'executorDismiss'
        this.isConfirmModalVisible = true
      }
    },

    executorReplace: function() {
      this.dialogMessage = 'Подтвердите замену исполнителя текущего процесса.'
      this.dialogConfirmCB = 'executorAssign'
      this.isConfirmModalVisible = true
    },

    callMethod: function ( methodName, data ) {
      // console.log( "Test method is running! Data: " + data );
      if ( methodName ) {
        this[methodName]( data );
      }
    },
    getAllStatus: function(current) {
        let processArr =  this.items.filter(process =>
        process.root_process_id && process.root_process_id === current.id)
        processArr = [current, ...processArr]
        return processArr
    },
    processCancel: function( confirmed = false ) {
      if (confirmed) {
        this.isConfirmModalVisible = false
        this.dialogMessage = ''
        this.dialogConfirmCB = ''

        if ( this.currentItem && this.currentItem.id ) {
          this.isLoadingModalVisible = true
          const processArr = this.getAllStatus(this.currentItem)
          for (let i = 0; i < processArr.length; i++) {
          let apiPath = apiRoutes.monitor.actions.cancel.replace('{process_id}', processArr[i].id)

          http.patch( apiPath ).then(response => {
            if (consoleDebug) {
              console.log("Ответ сервера на 'monitor.actions.cancel' процесса:")
              console.log(response)
            }

            this.isLoadingModalVisible = false

            if ( response.status == 200 ) {
              this.dialogMessage = 'Операция успешно выполнена.'

              this.uploadItem( processArr[i] )
            } else {
              this.dialogMessage = 'Произошла ошибка при выполнении операции.'
            }
            this.isInfoModalVisible = true
          }).catch(error => {
            console.warn(error)

            this.isLoadingModalVisible = false

            // Show error message.
            this.dialogMessage = 'Произошла ошибка при выполнении операции.'
            this.isInfoModalVisible = true
          })
          }
        }

      } else {
        this.dialogMessage = 'Подтвердите отмену выполнения текущего процесса.\nВнимание: этой действие необратимо!'
        this.dialogConfirmCB = 'processCancel'
        this.isConfirmModalVisible = true
      }
    },

    processHold: function( confirmed = false ) {
      if (confirmed) {
        this.isConfirmModalVisible = false
        this.dialogMessage = ''
        this.dialogConfirmCB = ''

        if ( this.currentItem && this.currentItem.id ) {
          this.isLoadingModalVisible = true
          const processArr = this.getAllStatus(this.currentItem)
          for (let i = 0; i < processArr.length; i++) {
          let apiPath = apiRoutes.monitor.actions.hold.replace('{process_id}', processArr[i].id)

          http.patch( apiPath ).then(response => {
            console.log("Ответ сервера на 'monitor.actions.hold' процесса:")
            console.log(response)

            this.isLoadingModalVisible = false

            if ( response.status == 200 ) {
              this.dialogMessage = 'Операция успешно выполнена.'

              this.uploadItem( processArr[i] )
            } else if ( response.status == 423 ) {
              this.dialogMessage = 'Данный процесс не может быть приостановлен (заморожен).'
            } else {
              this.dialogMessage = 'Произошла ошибка при выполнении операции.'
            }
            this.isInfoModalVisible = true
          }).catch(error => {
            console.warn(error)

            this.isLoadingModalVisible = false

            // Show error message.
            this.dialogMessage = 'Произошла ошибка при выполнении операции.'
            this.isInfoModalVisible = true
          })
          }
        }
      } else {
        this.dialogMessage = 'Подтвердите заморозку текущего процесса.'
        this.dialogConfirmCB = 'processHold'
        this.isConfirmModalVisible = true
      }
    },

    processResume: function( confirmed = false ) {
      if (confirmed) {
        this.isConfirmModalVisible = false
        this.dialogMessage = ''
        this.dialogConfirmCB = ''

        if ( this.currentItem && this.currentItem.id ) {
          this.isLoadingModalVisible = true
          const processArr = this.getAllStatus(this.currentItem)
          for (let i = 0; i < processArr.length; i++) {
          let apiPath = apiRoutes.monitor.actions.resume.replace('{process_id}', processArr[i].id)
          http.patch( apiPath ).then(response => {
            if (consoleDebug) {
              console.log("Ответ сервера на 'monitor.actions.resume' процесса:")
              console.log(response)
            }

            this.isLoadingModalVisible = false

            if ( response.status == 200 ) {
              this.dialogMessage = 'Операция успешно выполнена.'

              this.uploadItem( processArr[i] )
            } else {
              this.dialogMessage = 'Произошла ошибка при выполнении операции.'
            }
            this.isInfoModalVisible = true
          }).catch(error => {
            console.warn(error)

            this.isLoadingModalVisible = false

            // Show error message.
            this.dialogMessage = 'Произошла ошибка при выполнении операции.'
            this.isInfoModalVisible = true
          })
          }
        }

      } else {
        this.dialogMessage = 'Подтвердите возобновление выполнения текущего процесса.'
        this.dialogConfirmCB = 'processResume'
        this.isConfirmModalVisible = true
      }
    },

    getItemById: function ( itemId ) {
      return this.items.find(element => {
        return element.id === itemId
      })
    },

    getItemIndexById: function ( itemId ) {
      return this.items.findIndex(element => {
        return element.id === itemId
      })
    },

    selectItem: function ( currentItem ) {
      if ( this.currentItem.id && currentItem.id && this.currentItem.id === currentItem.id ) {
        // Diselect item.
        this.currentItem = ''
      } else {
        this.currentItem = currentItem

        this.isInputDataVisible = false
        this.isOutputDataVisible = false
        this.isInstructionVisible = false

        // Check selected item status for if upload its input & output data
        if ( ['running', 'finished', 'hold'].includes( this.currentItem.status ) ) {
          // Item data can be found.
          // Does its exists?
          if ( typeof this.currentItem.data === 'undefined' ) {
            // Need to check for data exists
            this.uploadItemData( this.currentItem )
            // this.uploadItemPorts( this.currentItem )
          }
        }
      }
    },

    updateItemById: function ( item ) {
      // if (consoleDebug) {
      //   console.log("updateItemById, item:")
      //   console.log(item)
      // }

      if (item && item.id) {
        let itemIndex = this.getItemIndexById( item.id )

        if ( itemIndex >= 0) {
          this.$set(this.items, itemIndex, item)
          // this.items.splice(itemIndex, 1, item)
          // console.log("updateItemById, this.items:")
          // console.log(this.items)
        } else {
          if (consoleDebug) console.warn("updateItemById, no item with ID found, ID: " + item.id)
        }
      } else {
        console.warn("updateItemById, no item or item.id found")
      }
    },

    /**
     * Upload process base data from server.
     */
    uploadItem: function ( item ) {
      if ( item.id ) {
        let apiPath = apiRoutes.monitor.process.replace( '{process_id}', item.id )

        http.get( apiPath ).then(response => {
          // this.$bpmDebug.log([
          //   "Ответ сервера на 'monitor.process':",
          //   response
          // ])

          if (response.status == 200 && response.data) {
            // And upload all process data (input, outputs, ports)
            this.uploadItemData( response.data )
            // this.uploadItemPorts( response.data )

            // Replace existing list item with a new value.
            this.updateItemById( response.data )
          }
        }).catch(error => {
          console.warn(error)
        })
      }
    },

    /**
     * Upload process input & output data from server if it does not exist yet.
     */
    uploadItemData: function ( item ) {
      if (item && item.id && typeof item.data === 'undefined') {
        this.loadingItemDataId = item.id

        let apiPath = apiRoutes.monitor.data.replace( '{process_id}', item.id )

        http.get( apiPath ).then(response => {
          this.loadingItemDataId = null

          if (response.status == 200 && response.data) {
            item.data = response.data
            //
            this.updateItemById( item )
          }
        }).catch(error => {
          this.loadingItemDataId = null
          console.warn(error)
        })
      }
    },

    /**
     * Upload process ports data from server if it does not exist yet.
     */
    uploadItemPorts: function ( item ) {
      if (typeof item.ports === 'undefined') {
        let apiPath = apiRoutes.monitor.ports.replace( '{process_id}', item.id )

        http.get( apiPath ).then(response => {
          // this.$bpmDebug.log([
          //   "Ответ сервера на 'monitor.ports' процесса:",
          //   response
          // ])

          if (response.status == 200 && response.data && response.data.data) {
            item.ports = response.data.data
            // TODO check response data structure & format
            this.updateItemById( item )
          }
        }).catch(error => {
          console.warn(error)
        })
      }
    },

    getRealDataWithDelay: debounce(
      function() {
        // console.log("Get Real Data (debounced)");
        this.getRealData()
      }, 1500
    ),

  }
}
</script>

<style lang="scss">
  #process-list-table td, #process-list-table th {
    padding: 3px 5px;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/apps/bpm/superMonitor/pages/ManageList.vue